<div class="main-content-incidencia">
  <div class="container-fluid">
    <div class="col-sm-12 col-md-12">
      <div
        class="btn-group"
        role="group"
        aria-label="Button group with nested dropdown"
      >
        <div class="btn-group" role="group" style="margin-left: 0px">
          <div class="" style="min-width: 250px">
            <!--Boton donde se muestra el proyecto-->
            <mat-form-field appearance="outline">
              <mat-select
                [(ngModel)]="selectProyecto"
                placeholder="Proyectos"
                (selectionChange)="capturarProyecto($event.value)"
                Id="proyecto"
                Name="proyecto"
              >
                <mat-option
                  *ngFor="let proyecto of proyectocliente"
                  placeholder="Proyectos"
                  [value]="proyecto.Id"
                  >{{ proyecto.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!--Boton donde se muestran las etapas-->
          <div
            class="btn-group"
            role="group"
            style="min-width: 250px; margin-left: 25px"
            *ngIf="selectProyecto"
          >
            <mat-form-field appearance="outline">
              <mat-select
                [(ngModel)]="selectEtapa"
                placeholder="Etapas"
                (selectionChange)="capturaretapa($event.value)"
                id="etapa"
                name="etapa"
              >
                <mat-option
                  *ngFor="let eta of etapacliente"
                  [value]="eta.idEtapa"
                >
                  {{ eta.NombreEtapa }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <!--Boton donde se dan de altas las incidencias-->
          <div style="margin-left: 25px" *ngIf="activaproyecto">
            <button
              *ngIf="activaproyecto"
              type="button"
              class="btn btn-info"
              mat-button
              (click)="openDialog()"
            >
              <i class="material-icons">add</i> Agregar
            </button>
          </div>
          <!--Boton para activar y desactivar los filtros-->
          <div *ngIf="activaproyecto" style="margin-left: 20px; width: 50px">
            <button
              type="button"
              [ngClass]="{ si: estadoPositivo, no: !estadoPositivo }"
              class="btn"
              (click)="activafiltros()"
            >
              <i class="material-icons">search</i>{{ texto }}
            </button>
          </div>
          <!--Captura de Filtos-->
          <div *ngIf="search" style="margin-left: 170px; min-width: 200px">
            <mat-form-field appearance="outline">
              <mat-select
                placeholder="Filtros"
                [formControl]="verFiltros"
                multiple
                (selectionChange)="capturafiltro($event.value)"
              >
                <mat-select-trigger>
                  {{ verFiltros.value ? verFiltros.value[0] : "" }}
                  <span
                    *ngIf="verFiltros.value?.length > 1"
                    class="example-additional-selection"
                  >
                    (+{{ verFiltros.value.length - 1 }}
                    {{ verFiltros.value?.length === 2 ? "other" : "others" }})
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let filtro of listatiposfiltros"
                  [value]="filtro.nombre"
                >
                  {{ cambiaEstatus(filtro.nombre) }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <!--Iniciamos con los filtros-->
      <div style="margin-top: 0%; padding: 0%">
        <!--Prioridad-->
        <div
          class="btn-group"
          role="group"
          *ngIf="prioridad"
          style="margin-left: 25px"
        >
          <div class="" style="min-width: 150px">
            <mat-form-field appearance="outline">
              <mat-select
                placeholder="Prioridad"
                [formControl]="prioridades"
                multiple
                (selectionChange)="applyFiltersIncidencias()"
              >
                <mat-select-trigger>
                  {{ prioridades.value ? prioridades.value[0] : "" }}
                  <span
                    *ngIf="prioridades.value?.length > 1"
                    class="example-additional-selection"
                  >
                    (+{{ prioridades.value.length - 1 }}
                    {{ prioridades.value?.length === 2 ? "other" : "others" }})
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let prioridad of listaprioridades"
                  [value]="prioridad.nombre"
                  >{{ prioridad.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!--Nombre-->
        <div
          class="btn-group"
          role="group"
          *ngIf="nombre"
          style="margin-left: 15px"
        >
          <div class="" style="min-width: 200px">
            <mat-form-field appearance="outline">
              <input
                matInput
                aria-label="Nombre de Incidencia"
                placeholder="Nombre de Incidencia"
                type="text"
                name="nombre"
                [(ngModel)]="titulo"
                id="nombre"
                maxlength="30"
                (keyup)="applyFiltersIncidencias()"
              />
            </mat-form-field>
          </div>
        </div>
        <!--Estatus-->
        <div
          class="btn-group"
          role="group"
          *ngIf="estatus"
          style="margin-left: 15px"
        >
          <div class="" style="min-width: 200px">
            <mat-form-field appearance="outline">
              <mat-select
                placeholder="Estatus"
                [formControl]="verestatus"
                multiple
                (selectionChange)="applyFiltersIncidencias()"
              >
                <mat-select-trigger>
                  {{ verestatus.value ? verestatus.value[0] : "" }}
                  <span
                    *ngIf="verestatus.value?.length > 1"
                    class="example-additional-selection"
                  >
                    (+{{ verestatus.value.length - 1 }}
                    {{ verestatus.value?.length === 2 ? "other" : "others" }})
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let topping of listaEstatus"
                  [value]="topping"
                  >{{ topping }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!--Fecha de nicio-->
        <div
          class="btn-group"
          role="group"
          *ngIf="fecha"
          style="margin-left: 15px"
        >
          <div class="" style="min-width: 200px">
            <mat-form-field appearance="outline">
              <input
                matInput
                aria-label="Fecha Incio:"
                [matDatepicker]="factura_Fecha_inicio"
                [(ngModel)]="fec_ini"
                (dateChange)="applyFiltersIncidencias()"
                placeholder="Fecha Incio: "
                [max]="maxDate"
              />
              <mat-datepicker-toggle matSuffix [for]="factura_Fecha_inicio">
              </mat-datepicker-toggle>
              <mat-datepicker #factura_Fecha_inicio></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <!--Fecha final-->
        <div
          class="btn-group"
          role="group"
          *ngIf="fecha"
          style="margin-left: 15px"
        >
          <div class="" style="min-width: 200px">
            <mat-form-field appearance="outline">
              <input
                matInput
                aria-label="Fecha Final:"
                [matDatepicker]="factura_Fecha_fin"
                [(ngModel)]="fec_fin"
                (dateChange)="applyFiltersIncidencias()"
                placeholder="Fecha Final: "
                [max]="maxDate"
              />
              <mat-datepicker-toggle matSuffix [for]="factura_Fecha_fin">
              </mat-datepicker-toggle>
              <mat-datepicker #factura_Fecha_fin></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <!--Numero de Incidencias-->
        <div
          class="btn-group"
          role="group"
          *ngIf="numero"
          style="margin-left: 15px"
        >
          <div class="" style="width: 200px">
            <mat-form-field appearance="outline">
              <input
                matInput
                [min]="1"
                aria-label="Número de Incidencia"
                placeholder="Número de Incidencia"
                type="number"
                name="numero"
                [(ngModel)]="numeroInci"
                id="numero"
                #numero
                (keyup)="applyFiltersIncidencias()"
                soloNumeroEntero
              />
            </mat-form-field>
          </div>
        </div>
        <!--Empleado-->
        <div
          class="btn-group"
          role="group"
          *ngIf="emp"
          style="margin-left: 15px"
        >
          <div class="" style="width: 250px">
            <mat-form-field appearance="outline">
              <mat-select [(ngModel)]="selectEmpleado" placeholder="Empleado">
                <mat-option
                  *ngFor="let emp of empleadocliente"
                  [value]="emp.idUsuario"
                >
                  {{ emp.nombreE }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- TERMINA FILTRO-->

      <!--Creacion de la tabla donde se van a visualizar las incidencias    -->

      <div
        *ngIf="activaproyecto"
        class="card-group"
        style="width: 1000px; margin-left: 20%"
      >
        <!-- Colunma de Abierto -->
        <div
          class="card-group ng-star-inserted"
          style="
            width: 250px;
            padding: 0%;
            height: auto;
            white-space: nowrap;
          "
        >
          <div
            class="card ng-star-inserted"
            style="width: 225px; height: 650px"
          >
            <div
              class="card-header text-center text-white"
              style="height: 50px; background-color: rgb(38, 166, 154)"
            >
              <span class="material-icons"> lock_open</span>
              <label
                style="margin-left: 10px; color: white"
                class="ng-star-inserted"
              >
                <h6 style="font-size-adjust: inherit">ABIERTO</h6>
              </label>
            </div>
            <div
              class="card-body text-center ng-star-inserted"
              style="overflow: auto"
            >
              <div class="ng-star-inserted">
                <mat-divider
                  class="mat-divider mat-divider-horizontal"
                  role="separator"
                  aria-orientation="horizontal"
                >
                </mat-divider>
                <!-- Primer ejemplo -->
                <div
                  class="card ng-star-inserted"
                  style="
                    width: 200px;
                    height: 230px;
                    margin-top: 0px;
                    word-wrap: break-word;
                    white-space: normal;
                    overflow: hidden;
                  "
                  *ngFor="
                    let abierto of Abierto
                      | paginate : { itemsPerPage: 3, currentPage: p }
                  "
                >
                  <div
                    class="card-header card-header-icon"
                    style="margin-bottom: -20px"
                  >
                    <label
                      class="card-title"
                      style="font-size: 14px"
                      matTooltip="{{ abierto.nombre }}"
                    >
                      <div
                        class="card-icon"
                        style="
                          width: 59px;
                          height: 25px;
                          padding: 3px;
                          margin: 0px 5px 0px 0px;
                          text-align: center;
                          color: white;
                          background-color: rgb(38, 166, 154);
                        "
                      >
                        {{ abierto.id }}
                      </div>
                      {{ abierto.nombre }}
                    </label>
                    <label
                      class="category text-muted"
                      style="font-size: 13px"
                      matTooltip="{{ abierto.descripcion }}"
                      >{{ abierto.descripcion }}</label
                    >
                  </div>
                  <div
                    class="card-body"
                    style="margin-bottom: -50px; margin-top: 0%"
                  >
                    <div
                      style="width: 110px; float: left; height: 73px"
                      class="ng-star-inserted"
                    >
                      <div class="media-left">
                        <span
                          class="material-icons"
                          style="
                            color: darkgray;
                            font-size: 18px;
                            margin-top: 5px;
                          "
                          >date_range
                        </span>
                        <label style="margin-top: 5px">
                          {{ abierto.fechaI }}</label
                        >
                      </div>
                      <span
                        class="material-icons"
                        style="
                          color: darkgray;
                          font-size: 18px;
                          margin-top: 5px;
                        "
                        matTooltip="{{ abierto.comentario }} comentarios "
                        >question_answer</span
                      >
                      <label style="margin-left: 1px; padding: 0%">
                        {{ abierto.comentario }}
                      </label>
                      <span
                        class="material-icons"
                        style="
                          color: darkgray;
                          font-size: 18px;
                          margin-left: 17px;
                          padding: 0%;
                          margin-top: 5px;
                        "
                        matTooltip="{{ abierto.archivos }} Archivos"
                        >ballot</span
                      >
                      <label style="margin-left: 1px; padding: 0%">
                        {{ abierto.archivos }}</label
                      >
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="stats">
                      <p
                        class="btn btn-sm btn-success"
                        style="font-size: 14px; font-weight: bold; width: 155px"
                        (click)="detallesIncidencia(abierto)"
                        (keydown.enter)="detallesIncidencia(abierto)"
                        [style.background]="abierto.color"
                      >
                        {{ abierto.BTP }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--Fin del primer ejemplo-->
                <mat-divider class="mat-divider"></mat-divider>
                <pagination-controls
                  responsive="true"
                  class="my-pagination"
                  (pageChange)="p = $event"
                  [autoHide]="false"
                  [previousLabel]="labels.previousLabel"
                  [nextLabel]="labels.nextLabel"
                ></pagination-controls>
                <div class="pagination-info mb-2 text-center">
                  <small class="text-muted">P&aacute;gina {{ p }} de {{ totalPagesAbierto || 1 }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Termina la colunma de Abierto-->

        <!-- Colunma de Observaciones -->
        <div
          class="card-group ng-star-inserted"
          style="
            width: 250px;
            padding: 0%;
            height: auto;
            white-space: nowrap;
          "
        >
          <div
            class="card ng-star-inserted"
            style="width: 225px; height: 650px"
          >
            <div
              class="card-header text-center text-white"
              style="height: 50px; background-color: rgb(255, 152, 0)"
            >
              <span class="material-icons"> visibility</span>
              <label
                style="margin-left: 10px; color: white"
                class="ng-star-inserted"
              >
                <h6 style="font-size-adjust: inherit">OBSERVACIONES</h6>
              </label>
            </div>
            <div
              class="card-body text-center ng-star-inserted"
              style="overflow: auto"
            >
              <div class="ng-star-inserted">
                <mat-divider
                  class="mat-divider mat-divider-horizontal"
                  role="separator"
                  aria-orientation="horizontal"
                >
                </mat-divider>
                <!-- Segundo ejemplo -->
                <div
                  class="card ng-star-inserted"
                  style="
                    width: 200px;
                    height: 230px;
                    margin-top: 0px;
                    word-wrap: break-word;
                    white-space: normal;
                    overflow: hidden;
                  "
                  *ngFor="
                    let observacion of Observacion
                      | paginate
                        : { itemsPerPage: 3, currentPage: p2, id: '201' }
                  "
                >
                  <div
                    class="card-header card-header-icon"
                    style="margin-bottom: -20px"
                  >
                    <label
                      class="card-title"
                      tyle="font-size: 14px;"
                      matTooltip="{{ observacion.nombre }}"
                    >
                      <div
                        class="card-icon"
                        style="
                          width: 59px;
                          height: 25px;
                          padding: 3px;
                          margin: 0px 5px 0px 0px;
                          text-align: center;
                          color: white;
                          background-color: rgb(255, 152, 0);
                        "
                      >
                        {{ observacion.id }}
                      </div>
                      {{ observacion.nombre }}
                    </label>
                    <label
                      class="category text-muted"
                      style="font-size: 13px"
                      matTooltip="{{ observacion.descripcion }}"
                      >{{ observacion.descripcion }}</label
                    >
                  </div>
                  <div
                    class="card-body"
                    style="margin-bottom: -50px; margin-top: 0%"
                  >
                    <div
                      style="width: 110px; float: left; height: 73px"
                      class="ng-star-inserted"
                    >
                      <div class="media-left">
                        <span
                          class="material-icons"
                          style="
                            color: darkgray;
                            font-size: 18px;
                            margin-top: 5px;
                          "
                          >date_range</span
                        >
                        <label style="margin-top: 5px">{{
                          observacion.fechaI
                        }}</label>
                      </div>
                      <span
                        class="material-icons"
                        style="
                          color: darkgray;
                          font-size: 18px;
                          margin-top: 5px;
                        "
                        matTooltip="{{ observacion.comentario }} comentarios"
                        >question_answer</span
                      >
                      <label style="margin-left: 1px; padding: 0%">
                        {{ observacion.comentario }}</label
                      >
                      <span
                        class="material-icons"
                        style="
                          color: darkgray;
                          font-size: 18px;
                          margin-left: 17px;
                          padding: 0%;
                          margin-top: 5px;
                        "
                        matTooltip="{{ observacion.archivos }} archivos"
                        >ballot</span
                      >
                      <label style="margin-left: 1px; padding: 0%">
                        {{ observacion.archivos }}</label
                      >
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="stats">
                      <p
                        class="btn btn-sm btn-success"
                        style="font-size: 14px; font-weight: bold; width: 155px"
                        (click)="detallesIncidencia(observacion)"
                        (keydown.enter)="detallesIncidencia(observacion)"
                        [style.background]="observacion.color"
                      >
                        {{ observacion.BTP }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--Fin del segundo ejemplo-->
                <mat-divider class="mat-divider"></mat-divider>
                <pagination-controls
                  responsive="true"
                  class="my-pagination2"
                  (pageChange)="p2 = $event"
                  id="201"
                  [autoHide]="false"
                  [previousLabel]="labels.previousLabel"
                  [nextLabel]="labels.nextLabel"
                >
                </pagination-controls>
                <div class="pagination-info mb-2 text-center">
                  <small class="text-muted">P&aacute;gina {{ p2 }} de {{ totalPagesObservacion || 1 }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Termina la columna de Observacion-->

        <!-- Colunma de Proceso -->
        <div
          class="card-group ng-star-inserted"
          style="
            width: 250px;
            padding: 0%;
            height: auto;
            white-space: nowrap;
          "
        >
          <div
            class="card ng-star-inserted"
            style="width: 225px; height: 650px"
          >
            <div
              class="card-header text-center text-white"
              style="height: 50px; background-color: rgb(33, 150, 243)"
              ng-reflect-ng-style="[object Object]"
            >
              <span _ngcontent-c3="" class="material-icons"> find_in_page</span>
              <label
                _ngcontent-c3=""
                style="margin-left: 10px; color: white"
                class="ng-star-inserted"
              >
                <h6 _ngcontent-c3="" style="font-size-adjust: inherit">
                  PROCESO
                </h6>
              </label>
            </div>
            <div
              class="card-body text-center ng-star-inserted"
              style="overflow: auto"
            >
              <div class="ng-star-inserted">
                <mat-divider
                  class="mat-divider mat-divider-horizontal"
                  role="separator"
                  aria-orientation="horizontal"
                >
                </mat-divider>
                <!-- Tercer ejemplo -->
                <div
                  class="card ng-star-inserted"
                  style="
                    width: 200px;
                    height: 230px;
                    margin-top: 0px;
                    word-wrap: break-word;
                    white-space: normal;
                    overflow: hidden;
                  "
                  *ngFor="
                    let proceso of Proceso
                      | paginate
                        : { itemsPerPage: 3, currentPage: p3, id: '301' }
                  "
                >
                  <div
                    class="card-header card-header-icon"
                    style="margin-bottom: -20px"
                  >
                    <label
                      class="card-title"
                      style="font-size: 14px"
                      matTooltip="{{ proceso.nombre }}"
                    >
                      <div
                        class="card-icon"
                        style="
                          width: 59px;
                          height: 25px;
                          padding: 3px;
                          margin: 0px 5px 0px 0px;
                          text-align: center;
                          color: white;
                          background-color: rgb(33, 150, 243);
                        "
                      >
                        {{ proceso.id }}
                      </div>
                      {{ proceso.nombre }}
                    </label>
                    <label
                      class="category text-muted"
                      style="font-size: 13px"
                      matTooltip="{{ proceso.descripcion }}"
                      >{{ proceso.descripcion }}</label
                    >
                  </div>
                  <div
                    class="card-body"
                    style="margin-bottom: -50px; margin-top: 0%"
                  >
                    <div
                      style="width: 110px; float: left; height: 73px"
                      class="ng-star-inserted"
                    >
                      <div class="media-left">
                        <span
                          class="material-icons"
                          style="
                            color: darkgray;
                            font-size: 18px;
                            margin-top: 5px;
                          "
                          >date_range</span
                        >
                        <label style="margin-top: 5px">{{
                          proceso.fechaI
                        }}</label>
                      </div>
                      <span
                        class="material-icons"
                        style="
                          color: darkgray;
                          font-size: 18px;
                          margin-top: 5px;
                        "
                        matTooltip="{{ proceso.comentario }} comentarios"
                        >question_answer</span
                      >
                      <label style="margin-left: 1px; padding: 0%">
                        {{ proceso.comentario }}</label
                      >
                      <span
                        class="material-icons"
                        style="
                          color: darkgray;
                          font-size: 18px;
                          margin-left: 17px;
                          padding: 0%;
                          margin-top: 5px;
                        "
                        matTooltip="{{ proceso.archivos }} archivos"
                        >ballot</span
                      >
                      <label style="margin-left: 1px; padding: 0%">
                        {{ proceso.archivos }}</label
                      >
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="stats">
                      <p
                        class="btn btn-sm btn-success"
                        style="font-size: 14px; font-weight: bold; width: 155px"
                        (click)="detallesIncidencia(proceso)"
                        (keydown.enter)="detallesIncidencia(proceso)"
                        [style.background]="proceso.color"
                      >
                        {{ proceso.BTP }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--Fin del tercer ejemplo-->
                <mat-divider class="mat-divider"></mat-divider>
                <pagination-controls
                  responsive="true"
                  class="my-pagination3"
                  (pageChange)="p3 = $event"
                  id="301"
                  [autoHide]="false"
                  [previousLabel]="labels.previousLabel"
                  [nextLabel]="labels.nextLabel"
                >
                </pagination-controls>
                <div class="pagination-info mb-2 text-center">
                  <small class="text-muted">P&aacute;gina {{ p3 }} de {{ totalPagesProceso || 1 }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Termina la columna de Proceso-->

        <!-- Colunma de Resultado -->
        <div
          class="card-group ng-star-inserted"
          style="
            width: 250px;
            padding: 0%;
            height: auto;
            white-space: nowrap;
          "
        >
          <div
            class="card ng-star-inserted"
            style="width: 225px; height: 650px"
          >
            <div
              class="card-header text-center text-white"
              style="height: 50px; background-color: rgb(145, 110, 255)"
              ng-reflect-ng-style="[object Object]"
            >
              <span _ngcontent-c3="" class="material-icons"> done_all</span>
              <label
                _ngcontent-c3=""
                style="margin-left: 10px; color: white"
                class="ng-star-inserted"
              >
                <h6 _ngcontent-c3="" style="font-size-adjust: inherit">
                  RESUELTO
                </h6>
              </label>
            </div>
            <div
              class="card-body text-center ng-star-inserted"
              style="overflow: auto"
            >
              <div class="ng-star-inserted">
                <mat-divider
                  class="mat-divider mat-divider-horizontal"
                  role="separator"
                  aria-orientation="horizontal"
                >
                </mat-divider>
                <!-- Cuarto ejemplo -->
                <div
                  class="card ng-star-inserted"
                  style="
                    width: 200px;
                    height: 230px;
                    margin-top: 0px;
                    word-wrap: break-word;
                    white-space: normal;
                    overflow: hidden;
                  "
                  *ngFor="
                    let resultado of Resultado
                      | paginate
                        : { itemsPerPage: 3, currentPage: p4, id: '401' }
                  "
                >
                  <div
                    class="card-header card-header-icon"
                    style="margin-bottom: -20px"
                  >
                    <label
                      class="card-title"
                      style="font-size: 14px"
                      matTooltip="{{ resultado.nombre }}"
                    >
                      <div
                        class="card-icon"
                        style="
                          width: 59px;
                          height: 25px;
                          padding: 3px;
                          margin: 0px 5px 0px 0px;
                          text-align: center;
                          color: white;
                          background-color: rgb(145, 110, 255);
                        "
                      >
                        {{ resultado.id }}
                      </div>
                      {{ resultado.nombre }}
                    </label>
                    <label
                      class="category text-muted"
                      style="font-size: 13px"
                      matTooltip="{{ resultado.descripcion }}"
                      >{{ resultado.descripcion }}</label
                    >
                  </div>
                  <div
                    class="card-body"
                    style="margin-bottom: -50px; margin-top: 0%"
                  >
                    <div
                      style="width: 110px; float: left; height: 73px"
                      class="ng-star-inserted"
                    >
                      <div class="media-left">
                        <span
                          class="material-icons"
                          style="
                            color: darkgray;
                            font-size: 18px;
                            margin-top: 5px;
                          "
                          >date_range</span
                        >
                        <label style="margin-top: 5px">{{
                          resultado.fechaI
                        }}</label>
                      </div>
                      <span
                        class="material-icons"
                        style="
                          color: darkgray;
                          font-size: 18px;
                          margin-top: 5px;
                        "
                        matTooltip="{{ resultado.comentario }} comentarios"
                        >question_answer</span
                      >
                      <label style="margin-left: 1px; padding: 0%">
                        {{ resultado.comentario }}</label
                      >
                      <span
                        class="material-icons"
                        style="
                          color: darkgray;
                          font-size: 18px;
                          margin-left: 17px;
                          padding: 0%;
                          margin-top: 5px;
                        "
                        matTooltip="{{ resultado.archivos }} archivos"
                        >ballot</span
                      >
                      <label style="margin-left: 1px; padding: 0%">
                        {{ resultado.archivos }}</label
                      >
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="stats">
                      <p
                        class="btn btn-sm btn-success"
                        style="font-size: 14px; font-weight: bold; width: 155px"
                        (click)="detallesIncidencia(resultado)"
                        (keydown.enter)="detallesIncidencia(resultado)"
                        [style.background]="resultado.color"
                      >
                        {{ resultado.BTP }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--Fin del cuarto ejemplo-->
                <mat-divider class="mat-divider"></mat-divider>
                <pagination-controls
                  responsive="true"
                  class="my-pagination4"
                  (pageChange)="p4 = $event"
                  id="401"
                  [autoHide]="false"
                  [previousLabel]="labels.previousLabel"
                  [nextLabel]="labels.nextLabel"
                >
                </pagination-controls>
                <div class="pagination-info mb-2 text-center">
                  <small class="text-muted">P&aacute;gina {{ p4 }} de {{ totalPagesResuelto || 1 }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Termina la columna Resultado-->
      </div>
      <!--Termina la tabla de incidencias-->
    </div>
  </div>
</div>
